import { IsNotEmpty } from 'class-validator';
import { EpimsBaseEntityDto } from './epim-base.dto';

export class EpimsBankDetailDto extends EpimsBaseEntityDto {
	@IsNotEmpty() BankName: string;

            SortCode: string;
	@IsNotEmpty() BeneficiaryAccountName: string;
	@IsNotEmpty() BeneficiaryAccountNumber: string;
	@IsNotEmpty() Branch: string;
	 BVN: string;
  Remark: string;
	@IsNotEmpty() StudentId: string;
	length: number;
}
